import { derived, writable } from "svelte/store";
import { teamStore } from "../../../../api-stores/license-store";

export const SIGN_IN_LICENSES = [
  "extension",
  "outreach",
  "ausConversations",
  "euConversations",
  "ukConversations",
  "usConversations",
  "inboxAgent",
  "notetaker",
];

export const assignLicenseModalProps = writable({
  show: false,
  userId: "",
  kind: "",
  originalLicenses: [],
});

export const modulesStore = derived(teamStore, ($teamStore) => {
  const { licenses = [] } = $teamStore;
  return licenses.filter(
    (license) =>
      license.permissionObject !== "team" &&
      !["alias", "viewer"].includes(license.kind),
  );
});

export const licenseModifications = writable({});

export const selectedLicenses = derived(
  [assignLicenseModalProps, modulesStore, licenseModifications],
  ([$assignLicenseModalProps, $modulesStore, $licenseModifications]) =>
    Object.fromEntries(
      $modulesStore.map((module) => {
        const hasModification = module.kind in $licenseModifications;
        const isCurrentlyAssigned =
          $assignLicenseModalProps.originalLicenses.includes(module.kind);
        const finalValue = hasModification
          ? $licenseModifications[module.kind]
          : isCurrentlyAssigned;
        return [module.kind, finalValue];
      }),
    ),
);

export const hasSignInLicense = derived(selectedLicenses, ($selectedLicenses) =>
  SIGN_IN_LICENSES.some((license) => $selectedLicenses[license]),
);

export const licenseAvailabilityInfo = derived(
  [teamStore, modulesStore],
  ([$teamStore, $modulesStore]) =>
    $teamStore.licenses
      ? Object.fromEntries(
          $modulesStore.map((module) => {
            const license = $teamStore.licenses.find(
              (l) => l.kind === module.kind,
            );
            const remaining = license
              ? (license.total || 0) - license.activeCount
              : 0;

            return [
              module.kind,
              {
                available: remaining > 0,
                remaining: Math.max(0, remaining),
              },
            ];
          }),
        )
      : {},
);

export const hasAnyLicensesAvailable = derived(
  [licenseAvailabilityInfo, selectedLicenses],
  ([$licenseAvailabilityInfo, $selectedLicenses]) =>
    Object.entries($licenseAvailabilityInfo).some(
      ([licenseKind, info]) => info.available || $selectedLicenses[licenseKind],
    ),
);

export const updateLicenseSelection = (moduleKind, checked) => {
  licenseModifications.update((current) => ({
    ...current,
    [moduleKind]: checked,
  }));
};
